var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordered mt16"},[_c('Title',[_vm._v("预防接种统计")]),_c('BaseEchart',{staticStyle:{"margin-top":"-10px","width":"100%","height":"440px"},attrs:{"option":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }